"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledSystem = require("styled-system");
var _default = _styledSystem.shadow;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJzaGFkb3ciXSwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcEdyb3Vwcy9zaGFkb3cudHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgc2hhZG93LCBTaGFkb3dQcm9wcyB9IGZyb20gJ3N0eWxlZC1zeXN0ZW0nO1xuXG4vKiBlc2xpbnQtZGlzYWJsZSAqL1xuZXhwb3J0IGludGVyZmFjZSBDdXN0b21TaGFkb3dQcm9wcyBleHRlbmRzIFNoYWRvd1Byb3BzIHt9XG5cbmV4cG9ydCBkZWZhdWx0IHNoYWRvdztcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUE7QUFBb0QsZUFLckNBLG9CQUFNO0FBQUEifQ==